export default () => ({
  trigger: {
    name: 'product_trade_in.read_explanation',
    params: {},
  },
  config: {
    event: {
      name: 'read_explanation',
      params: {
        sub_feature: null,
        subject_type: 'label',
        subject_id: 'trade_in_and_upgrade',
      },
    },
  },
});
